import { render, staticRenderFns } from "./#filebackup.vue?vue&type=template&id=c0b86260&"
import script from "./#filebackup.vue?vue&type=script&lang=js&"
export * from "./#filebackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports